var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComplaintGroupForm',{attrs:{"routeName":'ScreeningGroupManage',"listRouteName":'screening',"id":_vm.complaintGroupId,"modeGrp":'Screening'}})}
var staticRenderFns = []

export { render, staticRenderFns }